import  axios  from "axios";

export default class Page {

    constructor() {
        this.page = [];
        this.estados = [];
    }

    get_page() {
        axios.get(`${hst}json/get_banners/${pge}`)
        .then(function (response) {
            this.page = response.data;
        }.bind(this)).catch(function (error) {
            console.log(error);
        });
    }

    get_estados(){
        axios.post(`${hst}json/estados`, {
            pagina_id: pge
        }).then(function (response) {
            this.estados = response.data;
            console.log(response);
        }.bind(this)).catch(function (error) {
            console.log(error);
        });    
    }

}


// WEBPACK FOOTER //
// ./src/point/Page.js